module.exports = __webpack_public_path__ + "img/car.0e6c84c3.jpg";